import React from "react";
import tw, { styled } from "twin.macro";

const Container = styled.div`
  ${tw`relative`}
  background-color: ${(props) => props.color}
  padding-bottom: ${(props) => props.aspectRatio}%;

  > img {
    ${tw`
        absolute object-contain
        w-3/4 h-3/4
        left-1/2 -translate-x-1/2
        top-1/2 -translate-y-1/2
    `}
  }
`;

const LogoImgBackup = ({ aspectRatio = 100, src = "", color = "" }) => {
  return (
    <Container aspectRatio={aspectRatio} color={color}>
      <img src={src} />
    </Container>
  );
};

export default LogoImgBackup;
